import { render, staticRenderFns } from "./HuggyAnalytics.vue?vue&type=template&id=672dbb6e&scoped=true"
import script from "./HuggyAnalytics.vue?vue&type=script&lang=js"
export * from "./HuggyAnalytics.vue?vue&type=script&lang=js"
import style0 from "./HuggyAnalytics.vue?vue&type=style&index=0&id=672dbb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672dbb6e",
  null
  
)

export default component.exports